export default __webpack_public_path__ + "assets/temp.e54a98e0.png";